// Core lib dependencies.
import React                  from 'react';
import PropTypes from 'prop-types';

// Component dependencies.
import { HybridButton }       from './buttons.jsx';

// Misc dependencies.
import { capitalize,
  getLabel }           from '../utils/string.js';


/**
 * <pre>
 * Button group React components.
 *
 * Summary of responsibilities:
 *
 *  - set of components and helper functions to handle rendering and functionality for button groups.
 * </pre>
 *
 * @author Various
 * @namespace Common.Components.ButtonGroups
 */

/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
/* Components */

/**
 * Auth button group.
 *
 * @namespace
 * @memberOf Common.Components.ButtonGroups
 */
class AuthButtonGroup extends React.Component {

  /**
     * Constructor.
     *
     * @param {object} props The injected props
     */
  constructor(props) {

    super(props);

    // Bind methods.
    this.handleButtonClicked = this.handleButtonClicked.bind(this);
  }

  /* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
  /* Render methods */

  /**
     * Render the component. Compose child components as required.
     *
     * @return {ReactElement}
     */
  render() {

    // Button elements.
    const _buttons = this.props.networks.map(function(network, i) {

      const _networkName = capitalize(network);

      const props = {
        iconClass:      'xIcon xIcon'+_networkName,
        className:      'xButton xActionOauth xAction'+_networkName,
        onClick:        this.handleButtonClicked.bind(this),
        dataAttributes: {
          'data-ngx-network': network
        }
      };

      const _btn = <li className="xAction xActionOauthLogin" key={'oauth-'+network}>
        <HybridButton {...props}>
          {getLabel('buttons.loginPrefix')+' '+_networkName}
        </HybridButton>
      </li>;

      return (
        _btn
      );

    }.bind(this));

    // Toolbar elements.
    let toolbar = null;
    if (_buttons.length > 0){
      toolbar = <ul className="xToolbar xButtonToolbar xActionOauthButtons">{_buttons}</ul>;
    }

    return (
      <div className="xActionContainer xActionOauthLoginContainer">
        {toolbar}
        <div id="xOAuthStatus"><p/></div>
      </div>
    );
  }

  /* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
  /* Event handler methods */

  /**
     * Handler called when a button is clicked.
     *
     */
  handleButtonClicked(event) {

    // If we have been passed a click handler.
    if (this.props.onClick) {
      this.props.onClick(event);
    }
  }
}

/**
 * React PropTypes.
 *
 * @type {Object}
 * @property {Array} networks Array containing list of networks.
 * @property {Function} onClick Click handler function.
 */
AuthButtonGroup.propTypes = {
  networks: PropTypes.array,
  onClick:  PropTypes.func
};

/**
 * React default props.
 *
 * @type {Object}
 * @property {Array} networks Object
 * @property {Function} onClick Function
 */
AuthButtonGroup.defaultProps = {
  networks: [],
  onClick:  function() {
    console.log('no click handler defined');
  }
};

export { AuthButtonGroup };